import { SET_ALL_COMPANIES } from "../../../constants";

export const setAllCompanies = (companies: any = []) => ({
  type: SET_ALL_COMPANIES,
  payload: companies,
});
